import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppBootstrapStore } from '../services/app-bootstrap.service';
import { AuthService, Permission } from '@umss/shared/data-access';

export const permissionsGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const appBootstrap = inject(AppBootstrapStore);

  // Wait for app initialization
  if (!appBootstrap.ready()) {
    return true;
  }

  const requiredPermissions = route.data['permissions'] as
    | Permission
    | Permission[]
    | undefined;

  // If no specific permissions are required for the route, allow access.
  if (
    !requiredPermissions ||
    (Array.isArray(requiredPermissions) && requiredPermissions.length === 0)
  ) {
    console.warn(
      'A permission guard was declared but no required permissions were found'
    );
    return true;
  }

  // Check using AuthService
  if (auth.hasPermission(requiredPermissions)) {
    return true;
  }

  // User does not have permission
  router.navigate(['/error-403']);
  return false;
};
